import { render } from "./productsListPage.vue?vue&type=template&id=7be172b9"
import script from "./productsListPage.vue?vue&type=script&lang=js"
export * from "./productsListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__